export default "__VITE_ASSET__BuOQSbyt__"